export class RowFullError extends Error {
  private static readonly _msg = "Cannot add tile! Row already full.";

  constructor() {
    super(RowFullError._msg);
  }
}
